export const useSelf360RouteConfig = ({ invitationId, respondentId, lang }) => {
  return {
    welcome: () => `/Auto360/${invitationId}/${respondentId}/${lang}`,
    addRaters: () =>
      `/Auto360/${invitationId}/${respondentId}/${lang}/add-raters`,
    submit: () =>
      `/Auto360/${invitationId}/${respondentId}/${lang}/submit-result`,
  };
};
